// import { hot } from 'react-hot-loader/root';
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppWithRouterAccess from './AppWithRouterAccess';

import { makeStyles } from '@material-ui/core/styles';
import { Container } from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
  root: {
    background: `#f4f7fc`,
    height: '100%',
    position: 'relative',
    paddingLeft: 100,
    paddingTop: 5,
    paddingBottom: 50,
    fontFamily: 'Roboto, sans-serif',
    overflowY: 'auto'
  },
}));

function App() {

  const classes = useStyles(); 
  return (    
    <Container maxWidth="xl" className={ classes.root }>

      <Router>
        <AppWithRouterAccess/>
      </Router>
    </Container>
  );
}

// export default hot(App);
export default App;
